<template>
  <section id="newsletter" class="padding-top-bottom-120 newsletter">
      <div class="container">
        <div class="row">
          <div class="col-md-8 sunscription-wraper-outer col-md-offset-2 bg-fit" style="background:url(images/newsletter.png)">
            <div class="row">
              <div class="col-md-8 col-md-offset-2 padding-top-bottom-90">
                <div class="subscription-wraper text-center">
                    <div class="heading-wraper text-center">
                        <h4 class="">{{contactData.title}}</h4>
                        <hr class="heading-devider gradient-orange">
                    </div>
                    <div v-html="contactData.describe"></div>
                    <div class="col-md-4" v-html="contactData.contact_number">
                        
                    </div>
                    <div class="col-md-4" v-html="contactData.address">
                    </div>
                    <div class="col-md-4" v-html="contactData.email">
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'contact',
  props:['contactData']
}
</script>



// WEBPACK FOOTER //
// src/components/contact.vue